/**
 * Return vehicle data object for use throughout the app
 * We stringify and parse to make sure there are no references and that it's a fresh object
 *
 * @param {Object} data
 *
 * @returns {Object}
 */
export const vehicleData = (data = {}) => {
    return JSON.parse(JSON.stringify({
        id: null,
        colour: '',
        image: '',
        make: '',
        model: '',
        registration_number: '',
        ...data,
    }));
};

export default {
    vehicles: [],
}
